module.exports = __webpack_public_path__ + "img/item6.254428b2.png";